import * as R from 'ramda';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ManageContentService } from './manage-content.service';
import { FormControl } from '@angular/forms';
import PublicationItem from '@app/publication-item';
import PublicationSection from '@app/publication-section';

@Component({
  selector: 'app-manage-content',
  templateUrl: './manage-content.component.html',
  styleUrls: ['./manage-content.component.css']
})
export class ManageContentComponent implements OnInit {
  activeSectionId: number;
  activeSectionItems: PublicationItem[];
  activeSubSectionId: number;
  isEditPublicationItemActive: boolean;
  publicationId: string;
  publicationItemToEdit: PublicationItem;
  publicationSections: (PublicationSection & {subsections?: PublicationSection[]})[];
  sectionItems = {};
  searchCtrl: FormControl = new FormControl();
  searchQuery: string;

  activateSection(id) {
    this.activeSectionId = id;
    this.activeSubSectionId = null;

    this.activeSectionItems = this.filterSectionItems({
      items      : this.sectionItems[id],
      searchQuery: this.searchQuery,
    });
  }

  activateSubSection(params) {
    const
      subsections = this.publicationSections[
        R.findIndex(R.propEq('id', params.sectionId), this.publicationSections)
      ].subsections;

    this.activeSectionId = params.sectionId;
    this.activeSubSectionId = params.subSectionId;

    this.activeSectionItems = this.filterSectionItems({
      items      : this.sectionItems[params.subSectionId],
      searchQuery: this.searchQuery,
    });
  }

  constructor(
    private manageContentService: ManageContentService,
    private router: Router,
  ) {
    this.searchCtrl.valueChanges.subscribe(input => {
      this.searchQuery = input;

      if (this.activeSubSectionId) {
        this.activateSubSection({sectionId: this.activeSectionId, subSectionId: this.activeSubSectionId});
      } else {
        this.activateSection(this.activeSectionId);
      }
    });
  }

  editPublicationItem(params: {itemId: string, sectionId: string}) {
    this.publicationItemToEdit = R.find(R.propEq('id', params.itemId), this.sectionItems[params.sectionId]);
    this.isEditPublicationItemActive = true;
  }

  fetchSectionItems(params: {id: string, onSuccess?: (object) => void, parentId?: string}) {
    this.manageContentService
      .getPublicationSectionItems({id: this.publicationId, sectionId: params.id})

      .subscribe((sectionItemsData: PublicationItem[]) => {
        this.sectionItems[params.id] = sectionItemsData.map(R.clone);

        if (R.is(Function, params.onSuccess)) {
          params.onSuccess(sectionItemsData);
        }
      });
  }
  // Apply all possible filters here
  filterSectionItems(params: {items: PublicationItem[], searchQuery: string}) {
    return R.filter(
      item => !params.searchQuery || item.title.match(new RegExp(params.searchQuery, 'gi')),
      params.items,
    );
  }

  hideEditPublicationItem() {
    this.isEditPublicationItemActive = false;
  }

  toggleSectionItemProperty(params: {
    itemId: string,
    sectionId: string,
    property: 'featured_flag' | 'visible',
    state: boolean,
    subSectionId?: string
  }) {
    const
      section = this.sectionItems[params.subSectionId || params.sectionId];

    section[R.findIndex(R.propEq('id', params.itemId), section)][params.property] = params.state ? '1' : '0';
  }

  toggleSectionItemFeatured(params: {itemId: string, sectionId: string, state: boolean, subSectionId?: string}) {
    this.manageContentService.toggleSectionItemFeatured({id: params.itemId, state: params.state}).subscribe(() => {
      this.toggleSectionItemProperty(R.assoc('property', 'featured_flag', params));
    });
  }

  toggleSectionItemVisibility(params: {itemId: string, sectionId: string, state: boolean, subSectionId?: string}) {
    this.manageContentService.toggleSectionItemVisibility({id: params.itemId, state: params.state}).subscribe(() => {
      this.toggleSectionItemProperty(R.assoc('property', 'visible', params));
    });
  }

  ngOnInit() {
    this.publicationId = this.router.routerState.snapshot.root.firstChild.firstChild.params.id;

    this.manageContentService
      .getPublicationSections({id: this.publicationId})

      .subscribe((data: {sections: PublicationSection[]}) => {
        this.publicationSections = data.sections;

        // Fetch items or every section and subsection, all at once
        R.forEach(
          section => {
            this.fetchSectionItems({
              id: section.id,

              // If there are no subsections then activate first section right after it's items loaded
              ...(R.isEmpty(section.subsections || []) && !this.activeSectionId && {
                onSuccess: () => this.activateSection(section.id),
              }),
            });

            R.forEach(
              subSection => this.fetchSectionItems({
                id: subSection.id,

                // Activate first subsection of the first section
                ...(!this.activeSubSectionId && {
                  onSuccess: () => this.activateSubSection({sectionId: section.id, subSectionId: subSection.id}),
                }),
              }),

              section.subsections || [],
            );
          },

          this.publicationSections,
        );
      });
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/manage-content/manage-content.component.ts